import type { FaireProductEntity } from "../../entity_types/product";

export const p_wtpc3e73jd: FaireProductEntity = {
  token: "p_wtpc3e73jd",
  type: "product",
  name: "B*tch Be Gone Essential Oil Aromatherapy Roller | Funny Gifts",
  brandToken: "b_r5xk4t473s",
  brandName: "Blue Sage",
  imageUrl:
    "https://cdn.faire.com/fastly/c67d22d6369979128afe4f5bb445ca3c41e956f04b1c32ee3eff101e42e3817d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/21589a4c07c6e04ef0261853c3968ab56f3a62fba124126c781e8a014e0b67df.png",
    "https://cdn.faire.com/fastly/ce550c23537a5a3c9aaf3b51b702132572aab009a3480a75d2748e942bb61908.jpeg",
    "https://cdn.faire.com/fastly/a5230db975c29fff42bb62d4d80be43940e7128d7082730ddd4c6d2af0a340aa.jpeg",
    "https://cdn.faire.com/fastly/e55f85fee05a89b3f3a2bcc9395bc21250133acbe5074ee24edaaa5bcf91c47b.png",
    "https://cdn.faire.com/fastly/28c96613a0811d5048d82aa517c536891a54a272c54274a0b64f1e0ef296f8b6.jpeg",
  ],
  priceDollars: 6.93,
  description:
    "Bitch Be Gone Essential Oil Aromatherapy Roller\n\nBitch Be Gone, for when you need to quit your bitchin’ and get your shit together. Some days we just wake up on the wrong side of the bed and have a raging bitch streak that isn’t going to get us anywhere fast and need to shake up the mood. Step in ‘Bitch Be Gone’ blend. This relaxing yet uplifting scent will be sure to get you back on the right path and conquer the day! At least until it’s wine time. All of our oil blends are crafted right here by us in our studio!\n\nNOTES Top: Floral  | Mid: Zesty | Base: Warm + Spicy\n\nCarrier Oil:\n100% Cocos Nucifera – Fractionated \n\nEssential Oils (7.5% dilution):\nYlang ylang, Lavender, Bergamot, Juniper Berry, Patchouli\n\nHoliday Gift Ideas: Birthday, Christmas, Stocking Stuffer, Mother’s Day, Hanukkah, Thinking of You, Subscription Box",
  tags: [],
  msrpDollars: 13.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:42.496Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
